// src/pages/wallet.js

import React, { useEffect, useState } from "react";
import "../styles/wallet.css";
import { useAuth } from "../context/AuthContext";
import {
  getWallet,
  getWalletTransactions,
} from "../firebase";
import {
  FaWallet,
  FaArrowDown,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function Wallet() {
  const { user } = useAuth();

  const [wallet, setWallet] = useState({
    balance: 0,
    totalEarned: 0,
    totalWithdrawn: 0,
  });

  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;

    loadWallet();
  }, [user]);

  const loadWallet = async () => {
    try {
      setLoading(true);

      const walletData = await getWallet(user.uid);
      const txns = await getWalletTransactions(user.uid);

      setWallet(walletData);
      setTransactions(txns);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

 const requestWithdraw = () => {

  const phone = "918012044114";

  const message = `*Withdrawal Request*

Name: ${user.displayName || "Volunteer"}

Email: ${user.email || "-"}

Available Balance: ₹${wallet.balance || 0}

Total Earned: ₹${wallet.totalEarned || 0}

Total Withdrawn: ₹${wallet.totalWithdrawn || 0}

Please process my withdrawal.`;

  const url =
    `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(message)}`;

  window.open(url, "_blank");

};

  if (!user) {
    return (
      <div className="wallet-page">
        Please login.
      </div>
    );
  }

  return (
    <div className="wallet-page">

      <div className="wallet-header">

        <FaWallet className="wallet-icon" />

        <h2>My Wallet</h2>

      </div>

      <div className="wallet-card">

        <p className="wallet-label">
          Available Balance
        </p>

        <h1 className="wallet-balance">
          ₹{wallet.balance || 0}
        </h1>

      </div>

      

      <div className="wallet-summary">

        <div className="summary-box">

          <span>Total Earned</span>

          <h3>₹{wallet.totalEarned || 0}</h3>

        </div>

        <div className="summary-box">

          <span>Withdrawn</span>

          <h3>₹{wallet.totalWithdrawn || 0}</h3>

        </div>

      </div>

      <button
  className="withdraw-btn"
  onClick={requestWithdraw}
>
  Request Withdrawal
</button>

<div className="wallet-actions">

{/*
  <button
  className="wallet-action-btn"
  onClick={() => navigate("/creators")}
>
  <span>🎥</span>
  <span>Creator</span>
</button>
*/}
 

{/* Add Shop */}
  <button
    className="wallet-action-btn"
    onClick={() => navigate("/volunteers")}
  >
    <span>➕</span>
    <span>Add Shop (Volunteer)</span>
  </button>

  {/* Invite & Earn */}
  <button
    className="wallet-action-btn secondary"
    onClick={() => navigate("/invite")}
  >
    <span>🎁</span>
    <span>Invite & Earn</span>
  </button>

{/*
<button
  className="wallet-action-btn secondary"
  onClick={() => navigate("/products")}
>
  <span>🎁</span>
  <span>Refer & Earn</span>
</button>

*/}

</div>

      <div className="wallet-history">

        <h3>Transactions</h3>

        {loading ? (

          <p>Loading...</p>

        ) : transactions.length === 0 ? (

          <div className="empty-wallet">
            No transactions yet.
          </div>

        ) : (

          transactions.map((txn) => (

            <div
              className="wallet-item"
              key={txn.id}
            >

              <div className="wallet-left">

                <FaArrowDown className="wallet-arrow" />

                <div>

                  <strong>
                    {txn.reason}
                  </strong>

                  <p>
                    {txn.createdAt?.toDate
                      ? txn.createdAt
                          .toDate()
                          .toLocaleString()
                      : ""}
                  </p>

                </div>

              </div>

              <div className="wallet-credit">

                +₹{txn.amount}

              </div>

            </div>

          ))

        )}

      </div>

    </div>
  );
}